<template>
  <a-card size="small" :bordered="false">
    <template slot="title">
      <span style="margin-right: 4px">精准测试使用情况</span>
    </template>
    <div id="wk-use-count" :style="{ height: height, width: width }" />
  </a-card>
</template>

<script>
import { accurateUseAnalysis } from '@/api/data/workflow';
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      myChart: null,
      option: {
        grid: {
          left: '2%',
          right: '2%',
          bottom: '5%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category'
        },
        legend: {},
        yAxis: [
          {
            type: 'value',
            splitNumber: 4,
            splitLine: {
              show: true, // 显示分割线
              lineStyle: {
                color: ['rgba(0,0,0,0.1)'], // 分割线的颜色，可以设置为数组来显示不同颜色的虚线段
                width: 1, // 分割线的宽度
                type: 'dashed' // 分割线类型，'dashed' 表示虚线
              }
            },
            axisLabel: {
              show: true,
              interval: 'auto'
            }
          },
          {
            type: 'value',
            splitNumber: 4,
            splitLine: {
              show: true, // 显示分割线
              lineStyle: {
                color: ['rgba(0,0,0,0.1)'], // 分割线的颜色，可以设置为数组来显示不同颜色的虚线段
                width: 1, // 分割线的宽度
                type: 'dashed' // 分割线类型，'dashed' 表示虚线
              }
            },
            axisLabel: {
              show: true,
              interval: 'auto'
            }
          }
        ],
        series: [
          {
            type: 'line',
            showSymbol: false,
            zlevel: 3
          },
          {
            type: 'bar',
            showSymbol: false,
            yAxisIndex: 1,
            zlevel: 2
          }
        ],
        dataset: {
          source: [],
          dimensions: ['时间', '使用人数', '使用次数']
        }
      }
    };
  },
  watch: {
    filterForm() {
      this.getWorkflowUseCountData();
    }
  },
  mounted() {
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/bar');
    require('echarts/lib/chart/line');

    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    require('echarts/lib/component/grid');
    this.myChart = echarts.init(document.getElementById('wk-use-count'));
    this.getWorkflowUseCountData();
    setTimeout(() => {
      this.getDiagramData();
    }, 100); // 添加延迟
  },
  methods: {
    drawChart() {
      console.log(this.option);
      this.myChart.setOption(this.option, true);
      this.$nextTick(() => {
        this.myChart.resize();
      });
    },
    getWorkflowUseCountData() {
      this.loading = true;
      accurateUseAnalysis({ ...this.filterForm })
        .then(res => {
          this.option.dataset.source = res.data;
          this.loading = false;
          this.drawChart();
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped lang="less"></style>
